import { GuardModalService } from './guard-modal.service';
import { GuardModalEvent } from './guard-modal.event';

export
{
    GuardModalService,
    GuardModalEvent
};
